import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid/isg-grid.component';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { ColDef } from 'ag-grid-community';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CommonService } from '../../services/commonservice';

@Component({
  selector: 'picklistquestion',
  standalone: true,
  imports: [CommonModule, FormsModule, AccordionModule,
    ReactiveFormsModule, IsgGridComponent],
  providers: [CommonService],
  templateUrl: './page-picklist-question.component.html',
  styleUrl: './page-picklist-question.component.scss'
})
export class PagePicklistQuestionComponent extends BaseHttpReqRespService {
  @ViewChild('CreateCategoryModal') categoryModal!: TemplateRef<any>;
  @ViewChild('deleteOptionConfirmation') deleteOptionTemplate!: TemplateRef<any>;
  public questionOptionId!: string;
  public questionOptionList: questionOptions[] = [];
  myAppUrl: any;
  public questionId!: number;
  public folderId!: number;
  public mode!: string;
  public folderName!: string;
  MULTICHOICE_ENDPOINT = API_ENDPOINTS.MULTICHOICE;
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  QUESTION_MATRIX_ENDPOINT = API_ENDPOINTS.QUESTION_MATRIX;
  SURVEY_ENDPOINT = API_ENDPOINTS.SURVEY;
  showTitlePanel: boolean = true;
  showConfigPanel: boolean = false;
  pickListForm!: FormGroup;
  hideFolderName: boolean = false;

  quesCategoryForm!: FormGroup;

  public questionCategoryList: questionCategory[] = [];
  public questionCategoryId: number = 0;

  public width!: number;
  private gridApi: any;
  optionGridConfig: Partial<IsgGridConfig> = {
    height: '250px',
    pagination: false,
    rowDragManaged: true
  };
  public redirectedSectionId!: number;
  public redirectedSurveyId!: number;

  // Add state variables for accordion groups
  isQuestionTitleOpen: boolean = true;
  isOptionsConfigOpen: boolean = false;

  constructor(
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private _router: Router,
    public http: HttpClient,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private EncrDecr: EncrDecrService,
    @Inject('CONFIG_SETTINGS') configSettings: any
  ) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.myAppUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
  }
  backUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.folderId == -1)
        this._router.navigate(['/question']);
      else
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
    }
    else {
      this._router.navigate(['/programoverview']);
    }
  }
  saveQuestion() {
    if (this.pickListForm.valid) {
      if (this.questionId == undefined) {
        this.questionId = 0;
      }
      let userId = this.EncrDecr.get(localStorage.getItem('userId') ?? '');
      const questionViewModel = {
        description: this.pickListForm.controls.description.value,
        shortName: this.pickListForm.controls.shortName.value,
        questionId: this.questionId?.toString() ?? "0",
        type: "picklist",
        folderId: this.folderId?.toString() ?? "0",
        userId: userId,
        questionCategoryId: Number(this.pickListForm.controls.questionCategoryId.value) || 0,
        width: Number(this.pickListForm.controls.width.value) || 0
      };
      const data = JSON.stringify(questionViewModel);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
      this.commonService.httpPostWOHeader(
        this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.SAVE_QUESTION,
        data,
        httpOptions
      ).subscribe(result => {
        this.questionId = result;
        this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
        this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
        var location = window.location.pathname;
        if (location.includes("/client") == false) {
          if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
            this.mapQuestionsToSection(this.questionId, this.redirectedSurveyId, this.redirectedSectionId)
          }
        }
        else {
          if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
            this.mapQuestionsToSection(this.questionId, this.redirectedSurveyId, this.redirectedSectionId)
          }
        }
      });
    }
  }
  public resetQuestion() {
    this.pickListForm.controls.description.setValue("");
    this.pickListForm.controls.weightage.setValue("");

  }
  ngOnInit() {
    this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
    this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
    this.pickListForm = this.formBuilder.group({
      description: new FormControl('', Validators.required),
      questionOption: '',
      weightage: new FormControl(''),
      questionCategoryId: new FormControl(''),
      width: new FormControl(''),
      shortName: new FormControl(''),
      optionShortName: new FormControl('')
    });
    this.questionId = +this.route.snapshot.queryParams["questionId"];
    this.folderId = this.route.snapshot.queryParams["folderId"];
    this.folderName = this.route.snapshot.queryParams["folderName"];
    if (this.folderName != null || '') {
      this.hideFolderName = false;
    }
    else {

      this.hideFolderName = true;
    }
    if (this.questionId > 0) {
      this.mode = "Edit";
      this.getQuestion();
    }

    this.quesCategoryForm = this.formBuilder.group({
      'quesCategoryName': new FormControl(null, Validators.required)
    });

    this.getQuestionCategoryList();
  }

  getQuestionCategoryList() {
    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.QUESTION_CATEGORY_LIST).subscribe(result => {
      this.questionCategoryList = result;
    }, error => console.error(error));

  }

  AddQuesCategory() {
    let tmpQuesCategoryName = this.quesCategoryForm.get('quesCategoryName')?.value;
    let resourceIdList = "quesCategoryName=" + tmpQuesCategoryName;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(resourceIdList, this.myAppUrl + '/' + this.QUESTION_ENDPOINT.SAVE_CATEGORY, httpOptions).subscribe(result => {
      this.getQuestionCategoryList();
    }, error => console.error(error));
  }

  ResetQuesCategoryForm() {
    this.quesCategoryForm.reset();
  }


  getQuestion() {
    let parameter = "?questionId=" + this.questionId;
    this.commonService.httpGet("", this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.QUESTIONS + parameter).subscribe(response => {
      this.pickListForm.patchValue({
        description: response.description,
        questionCategoryId: response.questionCategoryId,
        width: response.width,
        shortName: response.shortName
      });
      this.questionOptionList = response.questionOptions;
    }, error => console.error(error));
  }
  addChoice() {
    if (this.questionOptionId == undefined) {
      this.questionOptionId = "0";
    }
    var existOption = this.questionOptionList
      .find(x => x.description == this.pickListForm.controls.questionOption.value
        && x.questionId == this.questionId && x.weightage == this.pickListForm.controls.weightage.value
        && x.optionShortName == this.pickListForm.controls.optionShortName.value);
    if (existOption == undefined) {
      this.addOption();
    }
    else {
      this.showMessage("Option Already Exists");
      this.messageTimeout();
    }
  }

  addOption() {
    if (this.questionOptionId == undefined) {
      this.questionOptionId = "0";
    }
    this.pickListForm.controls.description.setValue("pick List");
    if (this.pickListForm.controls.description.value != '' && this.pickListForm.controls.questionOption.value != '' && this.pickListForm.controls.questionOption.value != undefined) {
      var formData = new FormData();
      formData.append('option', this.pickListForm.controls.questionOption.value);
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
      const data = {
        option: this.pickListForm.controls.questionOption.value,
        questionId: this.questionId?.toString() ?? "0", // ensure string
        questionOptionId: this.questionOptionId?.toString() ?? "0", // ensure string
        weightage: this.pickListForm.controls.weightage.value,
        optionShortName: this.pickListForm.controls.optionShortName.value
      }
      this.commonService.httpPostWOHeader(
        this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.ADD_OPTION,
        data,
        httpOptions
      ).subscribe(result => {
        this.questionOptionList = result;
        this.questionId = this.questionOptionList[0].questionId;
        this.questionOptionId = '';
        this.pickListForm.patchValue({
          questionOption: "",
          weightage: "",
          optionShortName: ""
        });
      });
    }
  }
  showMessage(params: any) {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "block";
    }
    var message = document.getElementById('message');
    if (message) {
      message.innerText = params;
    }
  }
  messageTimeout() {
    window.setTimeout(() => {
      this.hideMessage();
    }, 1800);
  }
  hideMessage() {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "none";
    }
    var message = document.getElementById('message');
    if (message) {
      message.innerText = '';
    }
  }
  // Type your columnDefs as ColDef[]
  columnDefs: ColDef[] = [
    { headerName: 'QuestionOptionId', field: 'questionOptionId', hide: true, filter: true },
    { headerName: 'Options', field: 'description', rowDrag: true, filter: true, width: 340, cellRenderer: this.editOptionCellRenderer.bind(this), resizable: true },
    { headerName: 'Weight', field: 'weightage', filter: true, width: 250, resizable: true },
    { headerName: 'Short Name', field: 'optionShortName', filter: true, width: 250, resizable: true },
    { headerName: 'Delete', field: '', width: 100, cellRenderer: this.deleteOptionCellRenderer.bind(this), resizable: true }
  ];

  arrangeOrder() {
    var optionIdList = '';
    this.gridApi.forEachNode(function (rowNode: any) {
      optionIdList = optionIdList + rowNode.data.questionOptionId + ',';
    });
    const data = {
      questionId: this.questionId?.toString() ?? "0",
      optionIdList: optionIdList
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.commonService.httpPostWOHeader(
      this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.ARRANGE_QUESTION_OPTION,
      data,
      httpOptions
    ).subscribe(result => {
      this.questionOptionList = result.questionOptions;
    }, error => console.error(error));
  }

  editOptionCellRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const attr = this.renderer.createText(params.data.description);
    this.renderer.appendChild(element, attr);
    this.renderer.listen(element, 'click', () => {
      this.questionOptionId = params.data.questionOptionId;
      this.pickListForm.patchValue({
        questionOption: params.data.description,
        weightage: params.data.weightage === null ? '' : params.data.weightage,
        optionShortName: params.data.optionShortName
      });

    });
    return element;
  }
  deleteOptionCellRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa  fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.listen(element, 'click', () => {
      this.questionOptionId = params.data.questionOptionId;
      this.openDeleteOptionModal();
    });
    return element;
  }
  openDeleteOptionModal() {
    if (this.deleteOptionTemplate) {
      this.modalService.open(this.deleteOptionTemplate);
    }
  }
  onQuestionGridReady(params: any) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }
  deleteOptions() {
    let data = {
      questionId: this.questionId?.toString() ?? "0", // ensure string
      questionOptionId: this.questionOptionId?.toString() ?? "0"
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.commonService.httpPostWOHeader(
      this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.REMOVE_OPTION, data, httpOptions
    ).subscribe(data => {
      this.questionOptionList = data;
      // Refresh the grid
      if (this.gridApi) {
        this.gridApi.setRowData(this.questionOptionList);
      }
      this.questionOptionId = '';
    });
  }

  public resetForm() {
    this.questionOptionId = "0";
    this.pickListForm.controls.questionOption.setValue("");
    this.pickListForm.controls.weightage.setValue("");
    this.pickListForm.controls.optionShortName.setValue("");
    this.pickListForm.controls.description.setValue("");
  }
  mapQuestionsToSection(questionid: any, surveyId: any, currentSectionId: any) {
    var concatenated = questionid.toString();

    let questionIdList = "questionIdList=" + concatenated + "&surveyId=" + surveyId + "&sectionId=" + currentSectionId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(questionIdList, this.myAppUrl + '/' + this.SURVEY_ENDPOINT.MAP_QUESTION_TO_SECTION, httpOptions).subscribe(result => {
      window.setTimeout(() => {
      }, 1200);
    }, error => console.error(error));

  }
  backToSectionUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
        this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
      }
    }
    else {
      this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
    }
  }
  openCategoryModal() {
    if (this.categoryModal) {
      this.modalService.open(this.categoryModal);
    }
  }
}
interface questionOptions {
  questionId: number;
  questionOptionId: number;
  description: string;
  displayOrder: number;
  weightage: string;
  optionShortName: string;
}
interface choices {
  questionOption: string;
  description: string;

}

interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}

